import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import * as yup from "yup";
import { validate } from "shared/yup";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell, WidgetSelect } from "../widget-fields";
import { Switch } from "component/shared/switch";
import { getUser } from "redux/selector";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	style: string;
	showPropertyType?: boolean;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			style: "",
		}
	}

	private validationSchema = {
		style: yup
			.string()
			.required("Style is required.")
	};

	public render() {
		const { user } = this.props;
		const { style, showPropertyType } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.quickSearchWidget(
			user.websitePlatform,
			style,
			showPropertyType,
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell full>
						<WidgetSelect
							label="Style"
							required
							value={style}
							options={[
								{value: "universal", label: "Universal"},
								{value: "horizontal", label: "Horizontal"},
								{value: "vertical", label: "Vertical"},
								{value: "twoline", label: "Two Line"},
							]}
							onChange={(value) => this.setState({style: value}, () => {
								if (style === "universal") {
									this.setState({showPropertyType: undefined});
								}
							})}
						/>
					</WidgetFieldCell>
					{style && style !== "universal" &&
						<WidgetFieldCell full>
							<Switch
								label="Show Property Type"
								labelBold={false}
								checked={!!showPropertyType}
								onChange={(checked) => this.setState({showPropertyType: checked})}
							/>
						</WidgetFieldCell>
					}
				</WidgetFieldGrid>
			</WidgetConfigLayout>
		);
	}
}

export const QuickSearchConfig = connect(mapStateToProps, mapDispatchToProps)(Component);